export default __webpack_public_path__ + "static/media/Icon-14.ff6f496d.png";